import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../styles/diario.scss'
import moment from "moment";

const Diario = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchDiariosIn()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    const setArquivo = async (id) => {
        props.arquivo(id)
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>Edição Nº{props.diario.edicao} de {moment(props.diario.data_p).utc(false).format('dddd, DD [de] MMMM [de] YYYY')}</Card.Title>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.diario._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => setArquivo(props.diario._id)} variant='primary'>Mudar Arquivo</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.diario._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Diario;